// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"a0478d28","268":"db1df828","312":"48fd4802","372":"23b085d7","636":"cee3fc89","776":"f4ada3fa","871":"04fc1215","922":"219d9c1d"}[chunkId] + ".chunk.js";
};